import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { FileUploader } from 'ng2-file-upload';
import 'rxjs/Rx';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';

import { DataService } from '../../../services/data.service';

import { CheckFileImportTableField } from '../../../models/library-table-field';
import { GenericTableField } from '../../../models/generic-table-field';

@Component({
	selector: 'app-importa-pratiche',
	templateUrl: './importa-pratiche.component.html',
	styleUrls: ['./importa-pratiche.component.css']
})
export class ImportaPraticheComponent extends AppComponentGenericComponent implements OnInit {
	public formatter : any;

	private headers: HttpHeaders;
	uploader: FileUploader;
	uploadUrl: string = '/api/importa/pratiche';
	converterUrl: string;
	checkFileImportUrl: string;
	fileName: string;
	nuovaEmissione: string;

	checkResponse: any = null;
	importResponse: any = null;
	aggiornaAnagrafica: boolean = false;
	generazioneCompletata: boolean = false;

	gruppoTemplate: string = '';
	gruppiTemplate: any[] = [];
	gruppiTemplateSync: Subscription;
	comuneId: string;
	comuneSync: Subscription;

	importFile: boolean = false;
	fileCheckedError: boolean = false;
	fileChecked: boolean = false;
	importConveresion: boolean = false;
	acceptList: any[] = [
		{
			name: 'EXCEL',
			value: '.xls , .xlsx'
		},
		{
			name: 'CSV',
			value: '.csv'
		}
	];
	importFormGroup: FormGroup;

	constructor(protected dataService: DataService) {
		super(dataService, 'import-pratiche');
		this.formatter = this.dataService.getCommon().getLocale();
		let serverUrl = this.dataService.getCommon().getDB().serverUrl;
		this.checkFileImportUrl = serverUrl+'/proxy/import/pratiche/check_pratiche';
		this.converterUrl = serverUrl+'/proxy/import/pratiche/import_pratiche';
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');
		this.headers.append('Accept', 'application/json');

		this.uploader = new FileUploader({ url: this.uploadUrl });
		this.uploader.onCompleteAll = () => {
			console.log("onCompleteAll ok");
			this.importFile = true;
		};
	}

	ngOnInit() {
		this.importFormGroup = new FormGroup({
			acceptControl: new FormControl({ value: this.acceptList[0].value, disabled: false, }),
			nomeFileControl: new FormControl({ value: "", disabled: false, }),
			emissioniSelectedControl: new FormControl({ value: "", disabled: false, }),
        });
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			(comune) => {
				this.comuneId = comune.id;
			}
		);
		this.gruppiTemplateSync = this.dataService.templatesGruppi$.subscribe(
			gruppiTemplate => {
				this.gruppiTemplate = gruppiTemplate;
			}
		);
	}

	removeFiles(){
		this.fileCheckedError = false;
		this.fileChecked = false;
		this.checkResponse = null;
		this.importFormGroup.patchValue({nomeFileControl: ""});
		this.uploader.clearQueue();
		//console.log(this.uploader);
	}

	nameFormatter(name: string) {
		this.fileName = this.comuneId + '_' + name.split(' ').join('_').toLowerCase();
	}

	uploadFile(item: any){
		this.importResponse = null;

		this.nameFormatter(item.file.name);
		item.file.name = this.fileName;
		item.upload();
	}

	checkFileImport(){
		console.log("checkFileImport", this.uploader);
		this.dataService.openLoader('CONTROLLO FILE IMPORT','controllo file per import delle pratiche...');
		let acceptExtension = "";
		for(let acceptElement of this.acceptList){
			switch(acceptElement['name']){
				case 'CSV':
					if(acceptElement['value'] == this.importFormGroup.get('acceptControl').value)
						acceptExtension = "_csv";
					break;
				case 'EXCEL':
					if(acceptElement['value'] == this.importFormGroup.get('acceptControl').value)
						acceptExtension = "_excel";
					break;
				default:
			}
		}
		this.checkFileImportUrl += acceptExtension + ".php";
		console.log("checkFileImportUrl", this.checkFileImportUrl);
		let body: any = {
			fileName: this.fileName,
			comuneId: this.comuneId,
			aggiornamentoUtente: this.dataService.getUtentiService().getUser().id,
		};
		console.log('FILE CHECK', body);

		this.dataService.getCommon().getHttpClient().post<any>(this.checkFileImportUrl, JSON.stringify(body), { headers: this.headers })
		.subscribe(
			response => {
				console.log('CHECK RESPONSE', response);
				this.checkResponse = response;
				this.dataService.closeLoader();
				this.fileChecked = true;
				if(this.checkResponse['checkedFile']){
					this.fileCheckedError = !this.checkResponse['checkedFile'];
				}else{
					this.fileCheckedError = true;
				}
				console.log('CHECK RESPONSE fileChecked', this.fileChecked, "fileCheckedError", this.fileCheckedError);
			}
		);
	}

	fileConversion() {
		this.dataService.openLoader('IMPORTAZIONE PRATICHE','conversione e inizializzazione delle pratiche in corso...');
		let acceptExtension = "";
		for(let acceptElement of this.acceptList){
			switch(acceptElement['name']){
				case 'CSV':
					if(acceptElement['value'] == this.importFormGroup.get('acceptControl').value)
						acceptExtension = "_csv";
					break;
				case 'EXCEL':
					if(acceptElement['value'] == this.importFormGroup.get('acceptControl').value)
						acceptExtension = "_excel";
					break;
				default:
			}
		}
		this.converterUrl += acceptExtension + ".php";
		let body: any = {
			fileName: this.fileName,
			comuneId: this.comuneId,
			aggiornamentoUtente: this.dataService.getUtentiService().getUser().id,
			aggiornamentoData:  String(Math.floor(Date.now()/1000)),
			aggiornaAnagrafica: this.aggiornaAnagrafica,
			nuovaEmissione: this.nuovaEmissione,
			gruppoTemplate: this.gruppoTemplate
		};

		console.log('FILE CONVERTION', body);

		this.dataService.getCommon().getHttpClient().post<any>(this.converterUrl, JSON.stringify(body), { headers: this.headers })
			.subscribe(
				response => {
					console.log('IMPORT RESPONSE',response);
					this.importConveresion = true;
					this.importResponse = response;
					this.generazioneCompletata = true;
					this.dataService.closeLoader();
					this.dataService.refreshData("anagrafica");
					this.dataService.refreshData("pratiche");
				}
			);
	}

	apriPratiche() {
		this.dataService.navigateByUrl('/pratiche');
	}

	apriModifica($event){
	}

	apriNuovo(){
	}

	ngDestroy(){
		this.comuneSync.unsubscribe();
	}
}
// [disabled]="!checkPermission('importa-pratiche','write') || uploader.getNotUploadedItems().length"
